import React, { useState, useEffect } from "react";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Womensdaypayment = () => {
    const [name, setName] = useState("");
    const [mobile, setMobile] = useState("");
    const [district, setDistrict] = useState(""); // New state for district

    const [paymentMode, setPaymentMode] = useState("");
    const [transactionNo, setTransactionNo] = useState("");
    const [transactionDate, setTransactionDate] = useState("");
    const [remarks, setRemarks] = useState("");
    const [screenshot, setScreenshot] = useState(null);
    const [enteredAmount, setEnteredAmount] = useState(0);
    const [gstAmount, setGstAmount] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);


    const GST_PERCENT = 18;


  // Fetch available service types from service_master table on component mou



    const handleFileChange = (e) => {
        setScreenshot(e.target.files[0]);
    };

    // const handleAmountChange = (e) => {
    //     const amount = parseFloat(e.target.value);
    //     setEnteredAmount(amount);

    //     // Calculate GST and total amount
    //     const gst = (amount * GST_PERCENT) / 100;
    //     const total = amount + gst;

    //     setGstAmount(gst);
    //     setTotalAmount(total);
    // };

    const handleAmountChange = (e) => {
        const inputValue = e.target.value; // Get the raw input value
    
        // Allow only numeric input and prevent auto increment
        if (!/^\d*\.?\d*$/.test(inputValue)) return;
    
        const totalAmount = parseFloat(inputValue); // Convert input to number
        if (isNaN(totalAmount)) {
            setEnteredAmount(""); // Reset if invalid
            setGstAmount(0);
            setTotalAmount(0);
            return;
        }
    
        // Extract actual amount before GST
        const actualAmount = totalAmount / (1 + GST_PERCENT / 100);
        const gstAmount = totalAmount - actualAmount;
    
        setEnteredAmount(inputValue); // Keep manual entry without auto-increment
        setGstAmount(gstAmount.toFixed(2)); // Store GST amount
        setTotalAmount(totalAmount.toFixed(2)); // Store total amount
    };
    
    
    

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Retrieve logged-in username from localStorage
        const loggedInUser = localStorage.getItem("username");
        
        // Prevent submission if user is not logged in
        if (!loggedInUser) {
            alert("Please log in before submitting payment details.");
            return;
        }

        
        const formData = new FormData();
        formData.append("name", name);
        formData.append("mobile", mobile);
        formData.append("district", district); // Append district to form data
        formData.append("paymentMode", paymentMode);
        formData.append("transactionNo", transactionNo);
        formData.append("transactionDate", transactionDate);
        formData.append("remarks", remarks);
        formData.append("enteredAmount", enteredAmount);
        formData.append("gstAmount", gstAmount);
        formData.append("totalAmount", totalAmount);
        formData.append("cby", loggedInUser); // Append the logged-in user
        
        if (screenshot) {
            formData.append("screenshot", screenshot);
        }
    
        try {
            const response = await axios.post(`${API_BASE_URL}/api/other_payment_womens_day`, formData, {
                headers: { "Content-Type": "multipart/form-data" }
            });
            alert("Payment details added successfully!");
            window.location.reload();
        } catch (error) {
            console.error("Error saving payment details", error);
            alert(error.response?.data?.error || "An error occurred while saving payment details");
        }
    };
    

    return (
        <div className="bg-gray-100 p-1">
            <div className="max-w-2xl mx-auto p-6 mb-2">
                <div className="max-w-4xl mx-auto mt-12 bg-white shadow-lg rounded-lg p-8">
                    <h1 className="text-2xl font-semibold mb-6 text-blue-700">Add Other Payment</h1>
                    <form onSubmit={handleSubmit} className="space-y-4">
                        
                        {/* Name */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Name<span className="text-red-500">*</span></label>
                            <input type="text" value={name} onChange={(e) => setName(e.target.value)} required className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"/>
                        </div>

                        {/* Mobile Number */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Mobile No<span className="text-red-500">*</span></label>
                            <input type="text" value={mobile} onChange={(e) => setMobile(e.target.value)} required className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"/>
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700">District<span className="text-red-500">*</span></label>
                            <input type="text" value={district} onChange={(e) => setDistrict(e.target.value)} required className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"/>
                        </div>

                        {/* Payment Mode */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Payment Mode<span className="text-red-500">*</span></label>
                            <select value={paymentMode} onChange={(e) => setPaymentMode(e.target.value)} required className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2">
                                <option value="">Select Payment Mode</option>
                                <option value="Google Pay">Google Pay</option>
                                <option value="PhonePe">Phone PE</option>
                                <option value="AXIS Bank">AXIS Bank</option>
                                <option value="UPI Payment">UPI Payment</option>
                                <option value="Store Payment">Store Payment</option>
                                <option value="Razor Pay">Razor Pay</option>
                                <option value="Account Pay">Account Pay</option>
                                <option value="App Payment">App Payment</option>
                                <option value="Cash">Cash</option>
                                <option value="PAYTM">PAYTM</option>
                                <option value="Others">Others</option>
                                <option value="Free Mode">Free Mode</option>
                            </select>
                        </div>

                        {/* Transaction No */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Transaction No<span className="text-red-500">*</span></label>
                            <input type="text" value={transactionNo} onChange={(e) => setTransactionNo(e.target.value)} required className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"/>
                        </div>

                        {/* Transaction Date */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Transaction Date<span className="text-red-500">*</span></label>
                            <input
                                type="date"
                                value={transactionDate}
                                onChange={(e) => setTransactionDate(e.target.value)}
                                required
                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 cursor-pointer"
                                onKeyDown={(e) => e.preventDefault()} // Prevent manual input
                                onClick={(e) => e.target.showPicker()} // Open date picker when clicking anywhere
                            />
                        </div>

                        {/* Enter Amount */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Enter Amount<span className="text-red-500">*</span></label>
                            <input
                                type="number"
                                value={enteredAmount}
                                onChange={handleAmountChange}
                                required
                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                            />
                        </div>

                        {/* Upload Payment Screenshot */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Upload Payment Screenshot<span className="text-red-500">*</span></label>
                            <input type="file" accept="image/*" onChange={handleFileChange} required className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"/>
                        </div>

                        {/* Remarks */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Remarks</label>
                            <textarea value={remarks} onChange={(e) => setRemarks(e.target.value)} className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2" rows="3"></textarea>
                        </div>

                        <button type="submit" className="w-full bg-green-500 text-white font-bold py-2 rounded hover:bg-green-600">Save Payment Details</button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Womensdaypayment;



 




